/** Elenco delle notizie raccolte dal motore (F-109). */

import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';

export type NewsListItem = {
  id: string;
  title: string;
  url: string;
  /** Chi PUBBLICA (testata o dominio). */
  source: string | null;
  /** Chi CONSEGNA: `marketaux`, `finnhub`, `rss:<slug>`. */
  provider: string | null;
  language: string | null;
  publishedAt: string | null;
  fetchedAt: string;
  summary: string | null;
  sentiment: number | null;
  /** Vuoto = notizia di contesto di mercato, non agganciata a nessun titolo. */
  instruments: Array<{ instrumentId: string; symbol: string | null; name: string; sentiment: number | null }>;
};

export type NewsFilters = {
  q?: string | undefined;
  provider?: string | undefined;
  contextOnly?: boolean | undefined;
};

export function useNews(filters: NewsFilters = {}) {
  const params = new URLSearchParams();
  if (filters.q) params.set('q', filters.q);
  if (filters.provider) params.set('provider', filters.provider);
  if (filters.contextOnly) params.set('contextOnly', 'true');
  const query = params.toString();

  return useQuery({
    queryKey: ['news', 'list', filters.q ?? '', filters.provider ?? '', filters.contextOnly ?? false],
    queryFn: ({ signal }) =>
      api.get<{ items: NewsListItem[]; total: number; providers: string[] }>(
        query ? `/news?${query}` : '/news',
        signal,
      ),
  });
}
